import type { DistribuicaoArvoreProps } from "./types-distribuicao-arvore";
import { useDistribuicaoArvore } from "./use-distribuicao-arvore";
import { DistribuicaoArvoreView } from "./view-distribuicao-arvore";

export function DistribuicaoArvore(props: DistribuicaoArvoreProps) {
  const vm = useDistribuicaoArvore(props);

  return <DistribuicaoArvoreView {...vm} />;
}

export type * from "./types-distribuicao-arvore";
